import { CandidateSummary, ICandidateSummary } from "@/services/DTOs/CandidateSummary";

export interface INearbyCandidates {
  initialPosition: number;
  candidates: CandidateSummary[];
}

export class NearbyCandidates {
  public initialPosition: number;
  public candidates: CandidateSummary[];

  constructor(data: INearbyCandidates) {
    this.initialPosition = data.initialPosition;
    this.candidates = data.candidates.map((c) => new CandidateSummary(c as ICandidateSummary));
  }
}
